module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Mk14_C.ee47d930.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Mk14_C.png
// module id = ./src/assets/item/Weapon/Main/Item_Weapon_Mk14_C.png
// module chunks = 0